module.exports = __webpack_public_path__ + "tibet.svg?36936c3a3d92a389e3ec493946094ab2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/tibet.svg
// module id = 317
// module chunks = 10